import { KnowledgeBaseSnippetKind } from 'types'
import { string } from 'yup'
import { safify } from '../utils/safify'

export const productDescription = string()
  .default('')
  .meta({
    label: 'Product/Service Description',
    placeholder: 'Describe your product or service in 1-3 sentences',
    mobilePlaceholder: 'Describe your product in 1-3 sentences',
    snippets: [KnowledgeBaseSnippetKind.ProductOrServiceDescription],
    autoFill: true,
  })
  .transform(safify)
